require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./works-labs-iii-feature-complete.json") })
        }
      }, "path---works-labs-iii-feature-complete");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---works-labs-iii-feature-complete!./.cache/json/works-labs-iii-feature-complete.json
// module id = 381
// module chunks = 231608221292675